import axios from 'axios';
import {API} from '../../api/api';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {parseJwt_Expired} from '../../helper/parseJwtExpired';

export const makePaymentAction = createAsyncThunk(
    'makePaymentAction',
    async function (params, {rejectWithValue}) {
        const access_token_toxometris = localStorage.getItem('access_token_toxometris');
        access_token_toxometris && parseJwt_Expired(access_token_toxometris);

        try {
            const response = await axios.post(`${API.BASE_URL}/make_payment`,
                JSON.stringify(params), {
                    withCredentials: true,
                    headers: {
                        'Accept': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${access_token_toxometris}`,
                        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
                    }
                });
            const {data, status} = response;
            if (status === 200 && data.status === 'success' && data?.invoice_url) {
                return response.data
            } else {
                return rejectWithValue(response.data);
            }
        } catch (e) {
            return {message: e?.message || 'Something wnt wrong, please try later'}
        }
    }
);
const makePaymentSlice = createSlice({

    name: 'MAKE_PAYMENT_TOOLKIT',

    initialState: {
        loading: null,
        data: [],
        error: null,
        status: null
    },
    reducers: {
        // logoutAction() {
        //     localStorage.removeItem('access_token_toxometris');
        // },
        emptyData(state) {
            state.data = [];
            state.token = null;
            state.error = null;
        }
    },

    extraReducers: {
        [makePaymentAction.pending]: (state) => {
            state.status = 'CHOOSE_TEST_VALIDATE_REQUEST';
            state.error = null;
            state.loading = true;
        },

        [makePaymentAction.fulfilled]: (state, action) => {
            state.status = 'CHOOSE_TEST_VALIDATE_SUCCESS';
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        },

        [makePaymentAction.rejected]: (state, action) => {
            state.status = 'CHOOSE_TEST_VALIDATE_FAIL';
            state.loading = false;
            state.data = [];
            state.error = action.payload || {message: 'Something went wrong, please try later'};
        },
    }
});

export default makePaymentSlice.reducer;
export const {logoutAction, emptyData} = makePaymentSlice.actions;
